import { Eye } from 'lucide-react';
import { Link } from 'react-router-dom';

import { EmptyState, formatPersianNumber, formatSolarDate } from '../../../app/components/foundation';
import { VaniaLoadingSystem, VaniaTableSkeleton } from '../../../app/components/loading';
import { CommissionStatusBadge } from '../../commission/components/CommissionStatusBadge';
import type { Commission, CommissionSummary } from '../../commission/types/commission.types';

export interface TenantCommissionSectionProps {
  commissions: Commission[];
  summary: CommissionSummary | null;
  loading: boolean;
  error: string | null;
}

export function TenantCommissionSection({ commissions, summary, loading, error }: TenantCommissionSectionProps) {
  return (
    <div className="vania-tenant-commission-surface">
      <div className="vania-tenant-commission-header">
        <div>
          <h2 className="vania-tenant-workspace-card-title">کمیسیون</h2>
        </div>
        {summary && (
          <div className="vania-tenant-commission-summary" aria-label="خلاصه کمیسیون تننت">
            <span>رویدادها {formatPersianNumber(summary.event_count)}</span>
            <span className="is-paid">پرداخت‌شده {formatPersianNumber(summary.paid_total)} تومان</span>
            <span className="is-pending">در انتظار {formatPersianNumber(summary.pending_total)} تومان</span>
          </div>
        )}
      </div>

      {loading ? (
        <VaniaLoadingSystem mode="content" label="در حال بارگذاری کمیسیون‌های تننت">
          <VaniaTableSkeleton columns={5} rows={5} className="vania-tenant-commission-skeleton" />
        </VaniaLoadingSystem>
      ) : error ? (
        <p className="vania-tenants-status vania-tenants-status-error" role="alert">{error}</p>
      ) : commissions.length === 0 ? (
        <EmptyState message="کمیسیونی برای این تننت ثبت نشده است." />
      ) : (
        <div className="vania-tenant-commission-table-scroll">
          <table className="vania-tenant-commission-table">
            <thead>
              <tr>
                <th>نماینده</th>
                <th>مبلغ</th>
                <th>وضعیت</th>
                <th>منبع</th>
                <th>تاریخ</th>
                <th>عملیات</th>
              </tr>
            </thead>
            <tbody>
              {commissions.map((commission) => (
                <tr key={commission.id}>
                  <td className="vania-tenant-commission-name">
                    <span>{commission.representative_name || commission.representative_id}</span>
                    {commission.mobile && <small dir="ltr">{commission.mobile}</small>}
                  </td>
                  <td className="vania-tenant-commission-amount" dir="ltr">
                    {formatPersianNumber(commission.amount)} تومان
                  </td>
                  <td><CommissionStatusBadge status={commission.status} /></td>
                  <td>{commission.source_type}</td>
                  <td dir="ltr">{formatSolarDate(commission.created_at)}</td>
                  <td className="vania-tenant-commission-actions">
                    <Link to={`/commission/${commission.id}`} aria-label="مشاهده کمیسیون" title="مشاهده">
                      <Eye size={15} aria-hidden="true" />
                      <span className="sr-only">مشاهده</span>
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
